import { _ as _extends } from "@swc/helpers/_/_extends";
import { _ as _object_destructuring_empty } from "@swc/helpers/_/_object_destructuring_empty";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx } from "react/jsx-runtime";
import { LazyMadeInAustralia } from "@faire/retailer-visitor-shared/icons/MadeInCountry/LazyMadeInAustralia";
import { LazyMadeInCanada } from "@faire/retailer-visitor-shared/icons/MadeInCountry/LazyMadeInCanada";
import { LazyMadeInEurope } from "@faire/retailer-visitor-shared/icons/MadeInCountry/LazyMadeInEurope";
import { LazyMadeInEuropeanCountry } from "@faire/retailer-visitor-shared/icons/MadeInCountry/LazyMadeInEuropeanCountry";
import { LazyMadeInUSA } from "@faire/retailer-visitor-shared/icons/MadeInCountry/LazyMadeInUSA";
import React, { Suspense } from "react";
var MadeInCountrySuspense = function(param) {
    var children = param.children;
    return /*#__PURE__*/ _jsx(Suspense, {
        fallback: null,
        children: children
    });
};
export var MadeInUSA = function(_param) {
    var props = _extends({}, _object_destructuring_empty(_param));
    return /*#__PURE__*/ _jsx(MadeInCountrySuspense, {
        children: /*#__PURE__*/ _jsx(LazyMadeInUSA, _object_spread({}, props))
    });
};
export var MadeInCanada = function(_param) {
    var props = _extends({}, _object_destructuring_empty(_param));
    return /*#__PURE__*/ _jsx(MadeInCountrySuspense, {
        children: /*#__PURE__*/ _jsx(LazyMadeInCanada, _object_spread({}, props))
    });
};
export var MadeInEurope = function(_param) {
    var props = _extends({}, _object_destructuring_empty(_param));
    return /*#__PURE__*/ _jsx(MadeInCountrySuspense, {
        children: /*#__PURE__*/ _jsx(LazyMadeInEurope, _object_spread({}, props))
    });
};
export var MadeInEuropeanCountry = function(_param) {
    var props = _extends({}, _object_destructuring_empty(_param));
    return /*#__PURE__*/ _jsx(MadeInCountrySuspense, {
        children: /*#__PURE__*/ _jsx(LazyMadeInEuropeanCountry, _object_spread({}, props))
    });
};
export var MadeInAustralia = function(_param) {
    var props = _extends({}, _object_destructuring_empty(_param));
    return /*#__PURE__*/ _jsx(MadeInCountrySuspense, {
        children: /*#__PURE__*/ _jsx(LazyMadeInAustralia, _object_spread({}, props))
    });
};
